import { useState, useEffect } from "react";
import { useAppBridge } from "@shopify/app-bridge-react";
// components
import AskReview from "./AskReview";
import WriteReview from "./WriteReview";
// context
import useShopContext from "../../../hooks/useShopContext";
import useLocales from "../../../hooks/useLocales";
// constants
import { DATABASE_STATUTES, REVIEW_LINK } from "../../../common/constants";
import SetRatingModal from "./SetRatingModal";
import useSetInterval from "../../../hooks/useSetInterval";

const nameOfAskReviewModal = "showAskReviewModal";
// eslint-disable-next-line import/no-anonymous-default-export
export default function () {
  const [isWriteReviewShown, setShowWriteReview] = useState(false);
  const [rating, setRating] = useState(0);
  const [openRatingModal, setShowRatingModal] = useState(false);

  const {
    shop: {
      tutorial: { showAskReviewModal },
    },
    switchShowAskOrEmojiModal,
    status,
    sendReview,
  } = useShopContext();

  const showModal = useSetInterval({ intervalMin: 1 });

  const shopify = useAppBridge();

  const { translate } = useLocales();

  useEffect(() => {
    setRating(0);
  }, [showAskReviewModal]);

  const closeModalRatingReview = () => {
    setShowWriteReview(false);
    setShowRatingModal(false);
    switchShowAskOrEmojiModal(false, nameOfAskReviewModal);
  };

  const onClose = async () => {
    await sendReview({});
    closeModalRatingReview();
  };

  const handleSendReview = async (review) => {
    try {
      await sendReview({ rating, review });
      closeModalRatingReview();
    } catch {
      shopify.toast.show(`${translate("messages.error-occured")}`);
    }
  };

  const handleShowWriteReview = (rating = 0) => {
    if (rating <= 4) {
      setShowWriteReview(true);
    } else {
      if (rating === 5) {
        window.open(REVIEW_LINK, "_blank").focus();
        closeModalRatingReview();
      }

      sendReview({ rating });
    }
  };

  return (
    <>
      <AskReview
        open={showModal && showAskReviewModal && !openRatingModal && !isWriteReviewShown}
        onClose={onClose}
        setShowWriteReview={setShowWriteReview}
        setShowRatingModal={setShowRatingModal}
      />

      <SetRatingModal
        rating={rating}
        open={!!showAskReviewModal && openRatingModal && !isWriteReviewShown}
        onClose={onClose}
        onChangeRating={(value) => setRating(value)}
        handleShowWriteReview={handleShowWriteReview}
      />

      <WriteReview
        open={isWriteReviewShown}
        onClose={onClose}
        onWriteReview={handleSendReview}
        loading={status === DATABASE_STATUTES.LOADING}
      />
    </>
  );
}
